import {
  FetchArgs,
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  BaseQueryFn,
} from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line import/no-cycle
import { RootState } from '../store';
import { setCredentials, setLogout } from '../auth/auth.slice';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
// move to env

const baseQuery = fetchBaseQuery({
  baseUrl: BACKEND_URL,
  credentials: 'include',
});

const refreshTokenQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error) {
    if (result?.error.status === 403) {
      const refreshTokenResponse = await baseQuery(
        '/api/v1/auth/refresh',
        api,
        extraOptions
      );

      if (refreshTokenResponse?.data) {
        const { user } = (api.getState() as RootState).auth;
        if (user) {
          api.dispatch(setCredentials(user));
        }
        result = await baseQuery(args, api, extraOptions);
      } else {
        api.dispatch(setLogout());
      }
    }
  }

  return result;
};

const apiSlice = createApi({
  baseQuery: refreshTokenQuery,
  /* eslint-disable @typescript-eslint/no-unused-vars */
  // eslint-disable-next-line no-unused-vars
  endpoints: (_builder) => ({}),
  tagTypes: ['auth'],
});

export default apiSlice;
